import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap/dist/js/bootstrap.bundle.min.js"
import { ReactDOM } from 'react';
import { useEffect } from 'react';
import { BrowserRouter,Routes,Route } from 'react-router-dom';
import LoginForm from './LoginComponents/LoginForm';
import LoginAuth from './LoginComponents/LoginAuth';
import AppleSignInReturn from './LoginComponents/AppleSignInReturn';
import RegistrationForm from './RegistrationCommponents/RegistrationForm';
//import UserDashboard from './Dashboard/components/UserDashboard/UserDashboard';
import { Provider } from 'react-redux';
import store from './store'
import Alert from './BootstrapComponents/Alert';
import setAuthToken from './Utils/setAuthToken';
import { loadUser } from './Actions/Auth';
import LandingPage from './LandingPage/LandingPage';
//import { BookingsProvider } from './Dashboard/components/UserDashboard/BookingContext';
import Bookings from './BookingHistory/Bookings';

import StripePayment from './StripePayment/StripePayment';
import UserProfile from './UserProfile';
import ProtectedLayout from './Layout/ProtectedLayout';
import Dashboard from './Dashboard';
import 'react-toastify/dist/ReactToastify.css';
import Users from './Admin/Users';
import GuestUsers from './Admin/Users/GuestUsers';
import Locations from './Admin/Locations';
import Chargers from './Admin/Chargers';
import AdminBookings from './Admin/Bookings';
import {AdminContainer, SuperAdminContainer} from './Layout/components/AdminContainer';
// import SuperAdminContainer from './Layout/components/AdminContainer';
import LocationSelectionForm from './RegistrationCommponents/LocationSelectionForm';
import EmailVerification from './RegistrationCommponents/EmailVerification';
import ForgotPassword from './RegistrationCommponents/ForgotPassword';
// import {WebSocketProvider} from './Utils/WebSocketContext'
import WebSocketRouteWrapper from './Utils/WebSocketRouteWrapper'
import AdminConfig from './Admin/AdminConfig';
import Metric from './Admin/Metric';
import PageNotFound from './PageNotFound/PageNotFound';
import Timeline from './Dashboard/Timeline';
import Support from './Admin/Support';
import UserSupport from './Support';
import RefundForm from './Support/RefundForm';
import ViewSupportPage from './Admin/Support/ViewSupportPage';
import UserGroups from './Admin/UserGroups/UserGroups';
import Reports from './Admin/Reports/Reports';
import Deals from './Admin/Deals/Deals';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import Coupon from './Admin/CouponCode';
import MessageTemplates from './Admin/MessageTemplates';
import AdminUserGuide from './Admin/UserGuide';
import Payment from './Payment';
import UserGuide from './UserProfile/UserGuide'; 
import CustomerUserView from './Admin/Users/CustomerUserView';
import CustomerRateView from './Admin/Users/CustomerRateView';
import SiteInstallAndOnboarding from './Admin/SiteOnboardingTracker/SiteInstallAndOnboarding';
import EmailBroadcast from './EmailBroadcast/EmailBroadcast';
import LocationViewFromMail from './Dashboard/components/UserDashboard/LocationList/LocationViewFromMail';
import SoftwareVersion from './Admin/SoftwareVersion/SoftwareVersion';
import ComplianceVersionDisclosure from './Public/ComplianceVersionDisclosure/ComplianceVersionDisclosure';
import PrivacyPolicy from './Public/PrivacyPolicy/PrivacyPolicy';
import AccountDeletion from './Public/AccountDeletion/AccountDeletion';
import SupportFAQ from './Public/SupportFAQ/SupportFAQ';
import CustomerBookingView from './Admin/Users/CustomerBookingView';

if (localStorage.token){
  setAuthToken(localStorage.token)
}

function App() {
  useEffect(()=>{
    store.dispatch(loadUser())
  }, []); 
  
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);
  const options={
    mode: 'payment',
    currency: 'usd',
    amount: 100, // Convert to cents
    setup_future_usage: 'off_session'
}
  return (
    <Provider store={store}> 
    <div className="App">
      {/* <Alert></Alert> */}
      {/* <WebSocketProvider> */}
      {/* <Elements stripe={stripePromise} options={options}> */}
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginForm />} />
          <Route path="/login-auth" element={<LoginAuth />} />
          <Route path="/auth/applesignin" element={<AppleSignInReturn />} />
          <Route path="/registration" element={<RegistrationForm />} />
          <Route path="/registration/public" element={<RegistrationForm />} />
          <Route path="/registration/loc/coordinates/:lan/:lon" element={<RegistrationForm />} />
          <Route path="/registration/loc/:selectedLocation" element={<RegistrationForm />} />
          <Route path="/registration/loc/:selectedLocation/coupon/:couponCode" element={<RegistrationForm />} />
          <Route path="/registration/coupon/:couponCode" element={<RegistrationForm />} />
          <Route path="/location-selection" element={<LocationSelectionForm />} />
          <Route path="/verification/email/:verificationToken" element={<EmailVerification />} />
          <Route path="/forgot-password/:verificationToken" element={<ForgotPassword />} />
          
          <Route path="/" element={<ProtectedLayout />}>
              <Route element={<WebSocketRouteWrapper/>}>
              
                <Route index path='/' element={<Dashboard />}></Route>
                <Route index path='/timeline' element={<Timeline />}></Route>
                <Route index path='/users' element={<AdminContainer><Users /></AdminContainer>}></Route>
                <Route index path='/guest-users' element={<AdminContainer><GuestUsers /></AdminContainer>}></Route>
                <Route index path='/bookings' element={<AdminContainer><AdminBookings /></AdminContainer>}></Route>
                <Route index path='/metric' element={<AdminContainer><Metric /></AdminContainer>}></Route>
                <Route index path='/locations' element={<AdminContainer><Locations /></AdminContainer>}></Route>
                <Route index path='/software-version' element={<AdminContainer><SoftwareVersion /></AdminContainer>}></Route>
                <Route index path='/chargers' element={<AdminContainer><Chargers /></AdminContainer>}></Route>
                <Route index path='/supports' element={<AdminContainer><Support /></AdminContainer>}></Route>
                <Route index path='/supports/:selSupportInputID/view' element={<AdminContainer><ViewSupportPage /></AdminContainer>}></Route>
                <Route index path='/admin-config' element={<SuperAdminContainer><AdminConfig /></SuperAdminContainer>}></Route>
                <Route index path='/user-groups' element={<SuperAdminContainer><UserGroups /></SuperAdminContainer>}></Route>
                <Route index path='/reports' element={<SuperAdminContainer><Reports /></SuperAdminContainer>}></Route>
                <Route index path='/deals' element={<AdminContainer><Deals /></AdminContainer>}></Route>
                <Route index path='/coupon-code' element={<AdminContainer><Coupon /></AdminContainer>}></Route>
                <Route index path='/message-templates' element={<AdminContainer><MessageTemplates /></AdminContainer>}></Route>
                <Route index path='/app-guide' element={<AdminContainer><AdminUserGuide /></AdminContainer>}></Route>
                <Route index path='/payment' element={<Payment />}></Route>
                <Route index path='/customerUserView' element={<CustomerUserView></CustomerUserView>}></Route>  
                <Route index path='/customerRateView' element={<CustomerRateView></CustomerRateView>}></Route>
                <Route index path='/customerBookingView' element={<CustomerBookingView></CustomerBookingView>}></Route>
                <Route path='/siteOnboarding' element={<SiteInstallAndOnboarding></SiteInstallAndOnboarding>}></Route>
                <Route index path='/email-broadcast' element={<AdminContainer><EmailBroadcast/></AdminContainer>}></Route>
                <Route index path='/timeLine/:locId' element={<LocationViewFromMail></LocationViewFromMail>}></Route>


                <Route path='profile' element={<Elements stripe={stripePromise} options={options}><UserProfile/></Elements>}></Route>
                <Route path='support' element={<UserSupport/>}></Route>
                <Route path='bookingHist' element={<Bookings></Bookings>}></Route>
                <Route path='payment' element={<StripePayment/>}></Route>
                <Route path='userguide' element={<UserGuide></UserGuide>}></Route>
                
                {/* <Route path="profile" element={<Profile />} /> */}    
              </Route>
          
          </Route>
          <Route index path='/support/refund/:supportID' element={<RefundForm />}></Route>
          <Route path='/ctep-version-disclosure-h4k9x2mq7z' element={<ComplianceVersionDisclosure />}></Route>
          <Route path='/privacy-policy' element={<PrivacyPolicy />}></Route>
          <Route path='/delete-account' element={<AccountDeletion />}></Route>
          <Route path='/help' element={<SupportFAQ />}></Route>
          {/* <Route path='/.well-known/apple-developer-merchantid-domain-association'></Route> */}
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      
      </BrowserRouter>
      {/* </Elements> */}
      {/* </WebSocketProvider> */}
      {/* <LoginForm></LoginForm> */}
      {/* <RegistraionForm></RegistraionForm> */}
     
    </div>
    </Provider>
  );
}
// dep uat 1
export default App;
